import React, { useState } from 'react'
import { QuestionInputProps } from '../../questionTypes'

const NPS_LABELS: Record<string, string> = {
  0: 'Not at all likely',
  1: 'Not at all likely',
  2: 'Not likely',
  3: 'Not likely',
  4: 'Unlikely',
  5: 'Neutral',
  6: 'Neutral',
  7: 'Likely',
  8: 'Likely',
  9: 'Very likely',
  10: 'Extremely likely'
}

const NPS_SCALE = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

const npsBand = (n: number): 'detractor' | 'passive' | 'promoter' => {
  if (n >= 9) return 'promoter'
  if (n >= 7) return 'passive'
  return 'detractor'
}

export const NpsQuestion: React.FC<QuestionInputProps> = ({ value, onChange, readOnly = false }) => {
  const [hoveredNps, setHoveredNps] = useState<number | null>(null)
  const activeNps = hoveredNps ?? (value !== '' ? parseInt(value, 10) : -1)

  return (
    <div className='survey-response-question__nps'>
      <div className='survey-response-question__nps-scale' onMouseLeave={() => setHoveredNps(null)}>
        {NPS_SCALE.map((n) => (
          <button
            key={n}
            type='button'
            className={[
              'survey-response-question__nps-btn',
              `survey-response-question__nps-btn--${npsBand(n)}`,
              n <= activeNps && 'is-highlighted',
              value === String(n) && 'is-selected'
            ]
              .filter(Boolean)
              .join(' ')}
            onClick={() => onChange(String(n))}
            onMouseEnter={() => !readOnly && setHoveredNps(n)}
            disabled={readOnly}
            aria-label={`${n} - ${NPS_LABELS[String(n)]}`}
          >
            {n}
          </button>
        ))}
      </div>
      <div className='survey-response-question__nps-labels'>
        <span>Not at all likely</span>
        <span>Extremely likely</span>
      </div>
      {activeNps >= 0 && (
        <div className='survey-response-question__nps-feedback'>
          <span
            className={`survey-response-question__nps-feedback-label survey-response-question__nps-feedback-label--${npsBand(activeNps)}`}
          >
            {NPS_LABELS[String(activeNps)]}
          </span>
        </div>
      )}
    </div>
  )
}
